const mockupPath = (fileName) => `${process.env.PUBLIC_URL}/mockups/${fileName}`;

export const mockups = {
  feeling: mockupPath('mockup-1.svg'),
  reset: mockupPath('mockup-2.svg'),
  exercise: mockupPath('mockup-3.svg'),
  lighter: mockupPath('mockup-4.svg'),
  move: mockupPath('mockup-5.svg'),
  breathe: mockupPath('mockup-6.svg'),
  hold: mockupPath('mockup-7.svg'),
  starlight: mockupPath('mockup-starlight.svg'),
};

export const feelings = [
  { label: 'Angry', icon: '😡', className: 'warm' },
  { label: 'Overwhelmed', icon: '😵‍💫', className: 'green' },
  { label: 'Tired', icon: '😴', className: 'violet' },
  { label: 'Stressed', icon: '😅', className: 'sun' },
];

export const steps = [
  {
    title: 'Choose how you feel',
    text: "Pick what's best in this moment.",
    mockup: mockups.feeling,
  },
  {
    title: 'Begin your reset',
    text: "We'll guide you to slow down and settle.",
    mockup: mockups.reset,
  },
  {
    title: 'Follow a body-based exercise',
    text: 'Move, breathe, tap, or hold. Just follow along.',
    mockup: mockups.exercise,
  },
  {
    title: 'Feel a little lighter',
    text: 'Land, reflect, and choose to begin again.',
    mockup: mockups.lighter,
  },
];

export const exercises = [
  {
    title: 'Move',
    text: 'Gentle guidance to release tension and reset your body.',
    icon: '≋',
    accent: 'purple',
    mockup: mockups.move,
  },
  {
    title: 'Breathe',
    text: 'Soothing breath patterns to calm your nervous system.',
    icon: '♒',
    accent: 'blue',
    mockup: mockups.breathe,
  },
  {
    title: 'Tap',
    text: 'Simple tapping to ground yourself and ease stress.',
    icon: '◌',
    accent: 'pink',
    mockup: mockups.exercise,
  },
  {
    title: 'Hold',
    text: 'Comforting holds to create safety and regulation.',
    icon: '♡',
    accent: 'orange',
    mockup: mockups.hold,
  },
];

export const benefits = [
  { title: 'No overthinking', text: 'Just follow and feel the difference.', icon: 'lock', accent: 'purple' },
  { title: '1-minute resets', text: 'Short, effective, and easy to fit anywhere.', icon: 'clock', accent: 'pink' },
  { title: 'Private and gentle', text: 'Your experience stays with you, always.', icon: 'leaf', accent: 'green' },
  { title: 'Body-based support', text: 'Backed by nervous system science and compassion.', icon: 'heart', accent: 'orange' },
];
